import { mixin } from "../utils/mixin";
import { DirectContainer } from "./DirectContainer";
import { Container } from "./Container";
export class DirectContainerMixin extends Container {
    _appendChild(child) {
        // Ignore virtual dom operations.
    }
    _removeChild(child) {
        // Ignore virtual dom operations.
    }
    _insertBefore(child, anchor) {
        // Ignore virtual dom operations.
    }
    add(item) {
        item.parent = this;
        this.containerElement.childList.add(item.el);
    }
    itemInList(item) {
        return this.containerElement.childList.itemInList(item.el);
    }
    addAt(item, index) {
        item.parent = this;
        return this.containerElement.childList.addAt(item.el, index);
    }
    replace(item, prevItem) {
        return this.containerElement.childList.replace(item.el, prevItem.el);
    }
    setAt(item, index) {
        item.parent = this;
        this.containerElement.childList.setAt(item.el, index);
    }
    getAt(index) {
        const el = this.containerElement.childList.getAt(index);
        return el ? el.data : undefined;
    }
    getIndex(item) {
        return this.containerElement.childList.getIndex(item.el);
    }
    getByRef(ref) {
        var _a;
        return (_a = this.containerElement.childList.getByRef(ref)) === null || _a === void 0 ? void 0 : _a.data;
    }
    remove(item) {
        item.parent = undefined;
        this.containerElement.childList.remove(item.el);
    }
    removeAt(index) {
        const item = this.containerElement.childList.removeAt(index);
        item.data.parent = undefined;
    }
    clear() {
        this.containerElement.childList.getItems().forEach((item) => (item.data.parent = undefined));
        this.containerElement.childList.clear();
    }
    getChildren() {
        return this.containerElement.childList.getItems().map((element) => element.data);
    }
    getDirectChildren() {
        return this.getChildren();
    }
    setItems(items) {
        const [removed, added] = this.containerElement.childList.setItems(items.map((item) => item.el));
        items.forEach((item) => (item.parent = this));
        return [removed.map((e) => e.data), added.map((e) => e.data)];
    }
}
export function getDirectType(nodeType) {
    if (nodeType.prototype instanceof Container) {
        if (!nodeType.__direct) {
            // Create subclass.
            const directType = class extends nodeType {
            };
            mixin(directType, DirectContainer);
            nodeType.__direct = directType;
        }
        return nodeType.__direct;
    }
    else if (nodeType === Container) {
        return DirectContainer;
    }
    else {
        return nodeType;
    }
}
//# sourceMappingURL=direct.js.map